import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M15 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5","key":"svg-2"}],["path",{"d":"M6 10h4m-2 -2v4","key":"svg-3"}]]

const IconAmbulance = createReactComponent('outline', 'ambulance', 'Ambulance', __iconNode);

export default IconAmbulance;